'use client';

import { c as _c } from "react/compiler-runtime";
import type { ComponentType } from 'react';
import { BrandSpotlight } from './BrandSpotlight';
import HeroCardTile4up from './HeroCardTile4Up';
import { PromoCarousel } from './PromoCarousel';
import type { StorytellingCardUpProps, StorytellingVariant } from './types';
const components = {
  'Card Promo - Carousel': PromoCarousel,
  'Brand Spotlight': BrandSpotlight,
  'Hero Card 4 up': HeroCardTile4up
} as Record<StorytellingVariant, ComponentType<StorytellingCardUpProps>>;
export function StorytellingCardUp(props) {
  const $ = _c(3);
  const Component = components[props.variant] ?? "div";
  let t0;
  if ($[0] !== Component || $[1] !== props) {
    t0 = <Component {...props} />;
    $[0] = Component;
    $[1] = props;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}